/**
 * SuccessIcon/index.js
 * desc: success icon used for notification ui
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SuccessIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="success icon" label={ tooltip || translate('icons.success.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM6.996 11.789l2.926 2.985L17.353 7.2l.99 1.01-8.42 8.59L6 12.798l.996-1.01z"/></svg>
    </IconButton>
);


export default SuccessIcon;
